<template>
  <div>
      <b-row>
        <b-col>
          <!-- <div class="bimg"> -->
            <!-- <div :class="{imagePos : id== '11359'}" class="articleImage" v-if="postInfo.better_featured_image !== null" v-bind:style="{ 'background-image': 'url(' + postInfo.better_featured_image.source_url + ')' }">
            </div> -->
            <img :class="{imagePos : id== '11359'}" class="articleImage" :src="postInfo.better_featured_image.source_url">
          <b-container>
            <b-link to="/news" class="allNewsLink">
              <button class="Allbuttons">
                Back to Articles
              </button>
            </b-link>
            <h2 class="article-heading">
              <span v-html="postInfo.title.rendered"></span>
            </h2>
            <div class="mainArt">
              <span
                v-html="postInfo.content.rendered"
                class="newsDescript"
              ></span>
            </div>
          </b-container>
        </b-col>
      </b-row>
      <!-- <b-container>
        <div class="allPosts">
          <b-row class="latestAlpsNews">
            <b-col class="postRow">
              <Post :config="config" />
            </b-col>
          </b-row>
        </div>
      </b-container> -->
  </div>
</template>

<script>
import apiCall from "@/services/api.js";
// import Post from "@/components/posts.vue";
export default {
  name: "postFull",
  props: ["id", "config"],
  components: {
    // Post
  },
  data() {
    return {
      postInfo: []
    };
  },
  created() {
    const json = "wp/v2/posts?slug=" + this.$route.params.id ;
    apiCall
      .wpInfo(json)
      .then(({ data }) => {
        this.postInfo = data[0];
        this.loading = false;
      })
      .catch(error => {
        console.log(error);
        throw error;
      });
  }
};
</script>

<style scoped>
::v-deep img.wp-block-cover__image-background {
    width: 100%;
    height: auto;
}
@font-face {
	font-family: 'Grift-Bold'!important;
	font-weight: normal;
	font-style: normal;
	/* src: url('https://wp-mena.ocs-software.com/wp-content/themes/wp-bootstrap-starter/fonts/Grift-Regular.ttf'); */
	src: url('https://wp-mena.ocs-software.com/wp-content/themes/wp-bootstrap-starter/fonts/Grift-Bold.ttf')!important;
}
::v-deep p.has-large-font-size {
  font-size: 36px;
}
::v-deep p {
  margin-top: 0;
  margin-bottom: 2rem;
}
.Allbuttons {
  /* float: right; */
  width: 244px;
  height: 50px;
  background: transparent;
  color: #C8102E;
  font-weight: 500;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transition: all 0.4s ease;
  /* webkit-transition: all 350ms cubic-bezier(.37, 0, .63, 1); */
  transition: all 350ms cubic-bezier(.37, 0, .63, 1);
  margin-top: 30px;
}
.Allbuttons:hover {
  /* float: right; */
  width: 244px;
  height: 50px;
  background: #C8102E;
  color: #fff;
  font-weight: 500;
  border-radius: 50px;
  border: 1px solid #E8E8E8;
  transform: translateY(-10px);
  margin-top: 30px;
}
::v-deep figure.wp-block-image > img{
  width: 100%;
  max-height: max-content;
}
.articleImage.imagePos {
  background-position: bottom;
}
.articleImage {
  height: auto;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: top;
  width: 100%;
  /* background-position: center; */
}
.captionText {
  font-size: 13pt;
  padding: 10px;
  text-align: center;
}
.newslist {
  margin-top: 2em;
}
h2.article-heading {
  color: #C8102E;
  /* font-size: 26px; */
  font-size: 32px;
  font-weight: 600;
  margin-top: 50px;
  margin-bottom: 30px;
  font-family: 'Grift-Bold', sans-serif;
}
.newsDescript {
  font-size: 20px;
  /* padding: 20px 0; */
  color: #152229;
  font-family: 'Grift-Bold', sans-serif;
}
.mainArt {
  padding: 25px 0;
  padding-bottom: 100px;
}
.latest {
  background-color: #dfe1e6;
  color: #C8102E;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
  padding-top: 10px;
  padding-bottom: 10px;
}

.bimg {
  overflow: hidden;
  height: 500px;
}
.artImg {
  width: 100%;
}
@media only screen and (max-width: 480px) {
  .bimg {
    overflow: hidden;
    height: 300px;
  }
}
@media only screen and (max-width: 990px) {
  .latestAlpsNews {
    padding-left: 15px;
    padding-right: 15px;
  }
  ::v-deep #leftMore {
    color: #fff;
    background-color: #C8102E;
    border-radius: 10px;
    width: 20px;
    height: 20px;
    padding: 3px;
    text-align: left;
    vertical-align: bottom;
  }
  ::v-deep .moreNews>a  {
    background-color: transparent;
    color: #C8102E!important;
    text-align: left;
    /* vertical-align: middle; */
    margin-top: -12px;
    margin-bottom: 15px;
    padding-left: 5px;
  }
}
</style>
